import React from 'react'
import { Tag } from '../Tag'
import { IProps } from './index'

export const TagGroup: React.FC<IProps> = ({ tagData }) => {
  return (
    <ul className="tag-group">
      {tagData.map((tag) => (
        <li key={tag.text} className="tag-group__item">
          <Tag text={tag.text} url={tag.url} />
        </li>
      ))}
      <style jsx>
        {`
          .tag-group {
            display: block;
          }

          .tag-group__item {
            display: inline-block;

            & + & {
              margin-left: 0.5rem;
            }

            :global(a) {
              text-decoration: none;
            }
          }
        `}
      </style>
    </ul>
  )
}
